import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'wsb-sms-link-analytics',
  templateUrl: './sms-link-analytics.component.html',
  styleUrls: ['./sms-link-analytics.component.scss'],
  standalone: false
})
export class SmsLinkAnalyticsComponent {
  @Input() isSubscribed = true;
  @Output() insertPlaholder: EventEmitter<any> = new EventEmitter();

  fc: UntypedFormControl = new UntypedFormControl();
  url: UntypedFormControl = new UntypedFormControl();

  constructor(public activeModal: NgbActiveModal, private router: Router) {}

  insertPlaceH() {
    const linkAnalytics = {
      url: this.fc.value ? this.url.value : null,
      analyticsMode: this.fc.value ? 'DIRECT_URL' : 'ADDRESSBOOK'
    };
    this.insertPlaholder.emit(linkAnalytics);
  }

  goToShop() {
    this.router.navigate(['shop/index']);
    this.activeModal.close();
  }

  primaryDisabled() {
    if (this.fc.value) {
      return this.url.value ? false : true;
    }
    if (this.fc.value === false) {
      return false;
    }
    return true;
  }
}
